/* StudioSoie · Notre histoire (sections/ss-story.liquid) — run 10.
   Apparitions au défilement, barre de progression, sommaire flottant, frise qui se remplit, compteurs, étoiles Etsy,
   léger parallaxe du visuel d'ouverture. Vanilla ES5 ; respecte prefers-reduced-motion ; contenu visible sans JS. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ss-story]');
  if (!root || root._ssSt) { return; }
  root._ssSt = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  document.documentElement.classList.add('ss-st-js');

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---- compteurs : « 25 000+ » → 0 … 25 000 + ; années (1900–2100) et valeurs non numériques laissées telles quelles ---- */
  function countUp(el) {
    if (el._done) { return; } el._done = true;
    var raw = el.textContent.trim();
    var m = raw.match(/^([^0-9]*)([0-9][0-9\s  .,]*)(.*)$/);
    if (!m || reduce) { return; }
    var digits = m[2].replace(/[\s  .,]/g, '');
    var target = parseInt(digits, 10);
    if (!target || target < 20 || (digits.length === 4 && target >= 1900 && target <= 2100) || /[.,]\d{1,2}$/.test(m[2].trim())) { return; }
    var sep = (m[2].match(/[\s\u202f\u00a0.,](?=\d{3}(?!\d))/) || ['\u00a0'])[0];
    var fmt = function (n) { var s = String(n); return digits.length > 3 ? s.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : s; };
    var t0 = null, dur = 1400;
    function step(ts) {
      if (!t0) { t0 = ts; }
      var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = m[1] + fmt(Math.round(target * e)) + m[3];
      if (p < 1) { requestAnimationFrame(step); } else { el.textContent = raw; }
    }
    el.textContent = m[1] + fmt(0) + m[3];
    requestAnimationFrame(step);
  }

  /* ---- apparitions ---- */
  var reveals = qsa('[data-reveal]');
  function onIn(el) {
    el.classList.add('is-in');
    qsa('[data-ss-count]', el).forEach(countUp);
    if (el.hasAttribute('data-ss-count')) { countUp(el); }
    var stars = el.querySelector('.ss-st__etsy-stars'); if (stars) { setTimeout(function () { stars.classList.add('is-lit'); }, 250); }
  }
  if (hasIO && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { onIn(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el, i) { var sib = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0; el.style.transitionDelay = Math.min(sib, 4) * 70 + 'ms'; io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); var stars = el.querySelector('.ss-st__etsy-stars'); if (stars) { stars.classList.add('is-lit'); } });
  }
  /* compteurs hors des blocs [data-reveal] */
  qsa('[data-ss-count]').forEach(function (el) { if (!el.closest('[data-reveal]')) { if (hasIO) { var o = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { countUp(el); o.disconnect(); } }); o.observe(el); } } });

  /* ---- sommaire flottant ---- */
  var chapters = qsa('[data-chapter]').filter(function (c) { return (c.getAttribute('data-chapter') || '').trim() && c.id; });
  var nav = null, links = [];
  if (chapters.length > 2) {
    nav = document.createElement('nav');
    nav.className = 'ss-st__nav';
    nav.setAttribute('aria-label', root.getAttribute('data-nav-label') || 'Sommaire');
    chapters.forEach(function (c) {
      var a = document.createElement('a');
      a.href = '#' + c.id;
      a.innerHTML = '<i aria-hidden="true"></i><span></span>';
      a.querySelector('span').textContent = c.getAttribute('data-chapter');
      a.setAttribute('aria-label', c.getAttribute('data-chapter'));
      a.addEventListener('click', function (e) { e.preventDefault(); var y = c.getBoundingClientRect().top + window.pageYOffset - 90; window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); });
      nav.appendChild(a); links.push(a);
    });
    root.appendChild(nav);
  }
  var scrollLink = root.querySelector('.ss-st__scroll');
  if (scrollLink) { scrollLink.addEventListener('click', function (e) { var t = document.querySelector(scrollLink.getAttribute('href')); if (!t) { return; } e.preventDefault(); window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: reduce ? 'auto' : 'smooth' }); }); }

  /* ---- défilement : progression, frise, sommaire actif, parallaxe ---- */
  var bar = root.querySelector('[data-ss-st-progress]');
  var steps = root.querySelector('[data-ss-st-steps]'), line = root.querySelector('[data-ss-st-line]');
  var par = root.querySelector('[data-ss-st-parallax]');
  var ticking = false;
  function frame() {
    ticking = false;
    var vh = window.innerHeight, r = root.getBoundingClientRect();
    var total = Math.max(1, r.height - vh);
    var p = Math.min(1, Math.max(0, -r.top / total));
    if (bar) { bar.style.transform = 'scaleX(' + p.toFixed(4) + ')'; }
    if (steps && line) {
      var sr = steps.getBoundingClientRect();
      var lp = Math.min(1, Math.max(0, (vh * 0.62 - sr.top) / Math.max(1, sr.height)));
      line.style.transform = 'scaleY(' + lp.toFixed(4) + ')';
    }
    if (nav) {
      nav.classList.toggle('is-on', r.top < -vh * 0.4 && r.bottom > vh * 0.6);
      var cur = 0;
      chapters.forEach(function (c, i) { if (c.getBoundingClientRect().top < vh * 0.45) { cur = i; } });
      links.forEach(function (a, i) { var on = i === cur; a.classList.toggle('is-active', on); if (on) { a.setAttribute('aria-current', 'true'); } else { a.removeAttribute('aria-current'); } });
    }
    if (par && !reduce && window.innerWidth >= 990) {
      var pr = par.getBoundingClientRect();
      if (pr.bottom > 0 && pr.top < vh) { par.style.transform = 'translateY(' + (pr.top * -0.06).toFixed(1) + 'px)'; }
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  frame();
})();
